module.exports = __webpack_public_path__ + "static/img/p1.8ac918d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/article/importMp3/p1.png
// module id = FgzT
// module chunks = 0